"use strict";

(async function () {
    let YouTubeVideoID = "";
    const videoType = {
        showEditButton: true,
        itemFields: ["YouTubeVideoID"],
        addItem(createNewItemCallback) {
            Show_Dashboard_YouTubeDialog({
                callback(control, id, title) {
                    createNewItemCallback(title, {
                        YouTubeVideoID: id
                    });
                }
            });
        },
        editItem(title, itemFields, dashboardItem, editItemCallback) {
            Show_Dashboard_YouTubeDialog({
                callback(control, id, widgetTitle) {
                    editItemCallback(widgetTitle, {
                        YouTubeVideoID: id
                    });
                },
                id: itemFields.YouTubeVideoID,
                widgetTitle: title
            });
        },
        async onLoaded(dashboardItem, itemFields) {
            const content = `<div style=height:100%;overflow:hidden>
            <iframe id="YT_${EC_Fmt.MD5(itemFields.YouTubeVideoID)}" style=width:100%;height:100%;border:0 src="//www.youtube.com/embed/${itemFields.YouTubeVideoID}?wmode=transparent" allowfullscreen></iframe></div>`;
            dashboardItem.querySelector(".content").innerHTML = content;
        }
    };
    EWS.DashboardItemTypesManager.add("YoutubeVideo", videoType);
    EWS.DashboardItemTypesManager.add("YouTube Video", videoType);

    const pattern = /[\\?&]v=([^&#]*)/;

    const ParseYouTubeAddress = function (dialog, url) {
        let results = pattern.exec(url);
        let isNotNewFormat = true;

        if (results == null) {
            if (url.indexOf("https://youtu.be/") > -1) {
                results = url.replace("https://youtu.be/", "").trim();
                isNotNewFormat = false;
            }
        }

        if (results != null) {
            dialog.querySelector(".tips").classList.add("hidden");
            dialog.querySelector("#ews-youtube-preview").classList.remove("hidden");
            if (isNotNewFormat) {
                results = decodeURIComponent(results[1].replace(/\+/g, " "));
            }

            if (results !== YouTubeVideoID) {
                YouTubeVideoID = results;

                dialog.querySelector("#ews-youtube-preview").src = `//www.youtube.com/embed/${YouTubeVideoID}?wmode=transparent`;
                if (!dialog.querySelector("#ews-youtube-title").value) {
                    dialog.querySelector("#ews-youtube-title").value = "YouTube Video";
                }
            }
        } else {
            dialog.querySelector(".tips").classList.remove("hidden");
            dialog.querySelector("#ews-youtube-preview").classList.add("hidden");
            dialog.querySelector("#ews-youtube-preview").src = "about:blank";
            YouTubeVideoID = "";
        }
    };

    function Show_Dashboard_YouTubeDialog(insertArgs) {
        EWS.VerifySession(() => {
            // Task 1146755: Optimize Dashboard Widget-YouTube Video Implementation
            const content = `<div><ecp-sectionmessage type="information">Copy a YouTube video URL directly from your browser, and paste it into the 'URL' field</ecp-sectionmessage>
        <div class="flex margin-top-10">
            <div style="width:45%">
                <div>${EC_Fmt.Trn("YouTube URL")}</div><div><ecp-input type="text" id="ews-youtube-url"></div>
            </div>
            <div style="width:45%">
                <div>${EC_Fmt.Trn("Widget title")}</div><div><ecp-input type="text" id="ews-youtube-title" maxlength=50></div>
            </div>
        </div>
        <div class="margin-top-10">
            <div>${EC_Fmt.Trn("Preview")}</div>
            <div >
                <div class="hidden tips">
                    <ecp-empty illustration="warning">
                        <ecp-empty-title>Invalid YouTube URL</ecp-empty-title>
                        <ecp-empty-body>Check the provided URL and sure it starts with <b>https://youtube.com/watch?v=...</b> or <b>https://youtu.be/...</b></ecp-empty-body>
                    </ecp-empty>
                </div>
                <iframe id=ews-youtube-preview width=100% style="border:2px dashed var(--neutral-40)" height=265 src=about:blank ></iframe>
            </div>
        </div>
    </div>`;

            const Dialog = ECP.Dialog.ShowDialog(EC_Fmt.Trn("Insert YouTube video"), content, {
                width: 620,
                barPosition: "top",
                cancelButtonTitle: EC_Fmt.Trn("Cancel"),
                confirmButtonTitle: EC_Fmt.Trn("Insert video"),
                confirmButtonAction(dialog) {
                    const title = dialog.querySelector("#ews-youtube-title").value;
                    if (!EC_Fmt.isNull(YouTubeVideoID)) {
                        if (!EC_Fmt.isNull(insertArgs.callback)) {
                            ECP.Dialog.CloseDialog(dialog);
                            insertArgs.callback(dialog, YouTubeVideoID, title);
                        }
                    } else {
                        dialog.style.display = "block";
                        EWS.Alert(EC_Fmt.Trn("You must enter a YouTube video URL."));
                    }
                }
            });

            YouTubeVideoID = "";
            const youtubeUrl = Dialog.querySelector("#ews-youtube-url");
            if (insertArgs.id) {
                youtubeUrl.value = `https://youtu.be/${insertArgs.id}`;
                ParseYouTubeAddress(Dialog, youtubeUrl.value);
            }
            if (insertArgs.widgetTitle) {
                Dialog.querySelector("#ews-youtube-title").value = insertArgs.widgetTitle;
            }
            youtubeUrl.addEventListener("change", (e) => {
                ParseYouTubeAddress(Dialog, e.currentTarget.value);
            });
        });
    }
}());
